<template lang="pug">
el-dialog(
  v-dialogDrag
  append-to-body
  :close-on-click-modal="false"
  :close-on-press-escape="false"
  :title="depClassTitle"
  :visible.sync="depClassVisible"
  width="600px" )
  el-form( label-position="top" label-width="100px" :model="depClassForm" ref="depClassForm" :rules="rules" size="small" )
    el-form-item(label="分类名称" prop="deptCatalogue")
      el-input( v-model.trim="depClassForm.deptCatalogue" maxlength="30" placeholder="请输入分类名称" ref="deptCatalogue" show-word-limit size="small" )
    el-form-item(label="关联部门" prop="deptIds")
      el-cascader( v-model="depClassForm.deptIds" clearable :options="depOptions" :props="depDefaultProps" size="small" style="width: 100%" )
    el-form-item(prop="allowSubDeptVisit")
      el-checkbox( v-model="depClassForm.allowSubDeptVisit" :false-label="0" size="small" :true-label="1" ) 是否对子级部门人员进行数据开放
    el-form-item(label="文档管理员" prop="names")
      el-input(v-model="depClassForm.names" readonly size="small" )
        template(slot="append")
          el-button(size="small" @click="openUser") 选择文档管理员
  template(#footer)
    el-button(size="small" @click="closeDialog") 关闭
    el-button( size="small" type="primary" @click="submitEditdepClass" ) 确定
</template>

<script>
import { openMember } from "@/CommonDP/components/chooseMember/leftCom.js";
import orgService from "@/CommonDP/service/org-service";
import secondaryMenuService from "@/CommonDP/service/secondaryMenu-service.js";
import { mapState } from "vuex";
export default {
  props: {
    folderId: {
      type: String,
      default: ""
    }
  },
  data () {
    const deptCatalogueV = (rule, value, callback) => {
      var regExp = new RegExp('[\\\\|/:*<>?"]');
      if (value === "") {
        callback(new Error("请输入分类名称"));
      } else if (regExp.test(value)) {
        callback(new Error('分类名称不能包含以下字符:\\ / : * " ? < > |'));
      } else {
        callback();
      }
    };
    const namesV = (rule, value, callback) => {
      if (this.depClassForm.names === "") {
        callback(new Error("文档管理员不能为空"));
      } else {
        callback();
      }
    };
    return {
      depClassVisible: true,
      depClassForm: {
        deptCatalogue: "",
        allowSubDeptVisit: 1,
        deptIds: [],
        managerUserIds: [],
        names: ""
      },
      depOptions: [],
      depDefaultProps: {
        children: "children",
        label: "deptName",
        value: "deptId",
        checkStrictly: true,
        multiple: true,
        emitPath: false,
        expandTrigger: "hover"
      },
      userVoList: [],

      rules: {
        deptCatalogue: [{ required: true, trigger: "blur", validator: deptCatalogueV }],
        deptIds: [{ required: true, message: "请选择关联部门", trigger: "change" }],
        names: [{ required: true, trigger: "change", validator: namesV }]
      }
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    depClassTitle() {
      return this.folderId ? "编辑部门分类" : "新增部门分类";
    },
    requestParams() {
      const { deptCatalogue = "", allowSubDeptVisit = 1, deptIds = [] } = this.depClassForm;
      return {
        allowSubDeptVisit,
        deptCatalogue,
        deptIds,
        enterpriseId: this.enterpriseId,
        folderId: this.folderId,
        managerUserIds: this.userVoList.map(item => item.userId)
      };
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    async init() {
      if (this.folderId) {
        await this.queryEnterpriseDeptEdit();
      }
      this.queryDepList();
    },
    async queryEnterpriseDeptEdit() {
      const { data } = await secondaryMenuService.queryEnterpriseDeptEdit(this.folderId);
      const { allowSubDeptVisit = 1, deptCatalogue = "", deptIds = [], userVoList = [] } = data;
      this.depClassForm.allowSubDeptVisit = allowSubDeptVisit;
      this.depClassForm.deptCatalogue = deptCatalogue;
      this.depClassForm.deptIds = deptIds;
      this.userVoList = userVoList ;
      this.depClassForm.names = userVoList.map(item => item.name).join(",");
    },
    async queryDepList() {
      const { data } = await orgService.getOrgTree(this.enterpriseId);
      if (data) {
        this.depOptions = this.getTreeData(data) || [];
      }
    },
    getTreeData(data) {
      for (var i = 0; i < data.length > 0; i++) {
        if (data[i].children == null || data[i].children.length <= 0) {
          data[i].children = undefined;
        } else {
          this.getTreeData(data[i].children);
        }
      }
      return data;
    },
    async openUser() {
      const props = {
        codePri: ["User"],
        userIds: this.userVoList.map(item => item.userId).join(",")
      };
      const users = await openMember(props);
      this.userVoList = users;
      this.depClassForm.names = users.map(item => item.name).join(",");
    },
    closeDialog() {
      this.depClassVisible = false;
      this.reject();
    },
    async submitEditdepClass() {
      await this.$refs.depClassForm.validate();
      if (!this.folderId) { // 新增
        await secondaryMenuService.addEnterpriseDept(this.requestParams);
        this.$message.success("添加成功");
      } else { // 编辑
        const params = {
          ...this.requestParams,
          folderId: this.folderId
        };
        await secondaryMenuService.updateEnterpriseDept(params);
        this.$message.success("编辑成功");
      }
      this.resolve();
    }
  }

};
</script>

<style>

</style>
